import { AvailableOperationStatus } from '../operations/available-operation-status';
import { OperationRequest } from '../operations/operation-request';
import { Routes } from '../routes';
import { Strategy } from './abstract-strategy';

export class IntroductionStrat extends Strategy {
    public hasCondition(request: OperationRequest): boolean {
        const availableStatus = [
            AvailableOperationStatus.PENDIENTE,
            AvailableOperationStatus.ACTIVA,
            AvailableOperationStatus.PENDIENTE_ENTREGA,
            AvailableOperationStatus.NO_ENTREGADO
        ];

        const hasAvailableStatus = availableStatus.includes(request.state);
        const hasNoDocument = !request.idDocument && !request.documentList;
        const hasFinishCircuit = request.hasFinishCircuit;
        const offShowIntroPage = request.offShowIntroPage;
        const hasNoError = !request.hasError;
        if (request.idOperation && !offShowIntroPage && hasAvailableStatus && hasNoDocument && hasFinishCircuit && hasNoError) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.INTRO;
    }
}
